export default "__VITE_ASSET__DAnyaiNp__"